import { createContext, useContext, ReactNode } from "react";
import { UseFormReturn } from "react-hook-form";

interface ProductFormContextProps {
  form: UseFormReturn<any, any>;
  isSubmitting: boolean;
  canEditRefP: boolean;
  isAReceptionRefProduct: boolean;
  isReferenced: boolean;
  company: any;
  product?: any;
  productError?: string;
  currentCompany: string | null;
  onReset: () => void;
  defaultValuesForm?: any;
}

export const ProductFormContext = createContext<
  ProductFormContextProps | undefined
>(undefined);

interface ProductFormProviderProps {
  children: ReactNode;
  value: ProductFormContextProps;
}

export const ProductFormProvider = ({
  children,
  value,
}: ProductFormProviderProps) => {
  return (
    <ProductFormContext.Provider value={value}>
      {children}
    </ProductFormContext.Provider>
  );
};

export const useProductFormContext = () => {
  const context = useContext(ProductFormContext);
  if (context === undefined) {
    throw new Error(
      "useProductFormContext must be used within a ProductFormProvider"
    );
  }
  return context;
};
